module.exports = __webpack_public_path__ + "img/perfilador.b803e8ca.png";